import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HbsPreview.module.css';

function HbsPreview({ index, bulletinData }) {
	const navigate = useNavigate();
	const thisBulletinData = bulletinData[index];
	let mousePos;

	return (
		<div
			className={`${styles.card} ${styles.nonDrag}`}
			onMouseDown={(e) => (mousePos = [e.clientX, e.clientY])}
			onMouseUp={(e) => {
				if (!mousePos) return;
				if (
					Math.abs(e.clientX - mousePos[0]) < 2 &&
					Math.abs(e.clientY - mousePos[1]) < 2
				) {
					window.open(`https://hbs.geogo.org/reader/?${index}`);
				}
			}}
		>
			<img
				className={styles.previewImg}
				height={'100%'}
				src={`previews/p${index}.webp`}
				alt={`${index}'s preview`}
				loading="lazy"
			/>
			<button
				style={{
					position: 'absolute',
					right: 20,
					bottom: 5,
					border: 'none',
					padding: '3px 0',
					color: 'rgb(140, 130, 120)',
					fontSize: 12,
					cursor: 'pointer',
					backgroundColor: 'transparent',
				}}
				onClick={(_) => {
					navigate(`/detail/${index}`);
				}}
				onMouseUp={(e) => {
					e.stopPropagation();
				}}
			>
				자세히 보기
			</button>
			<div className={styles.content}>
				<div className={styles.describeContent}>
					<span className={styles.describe}>제목</span> {`${thisBulletinData.title}`}
				</div>
				<div className={styles.describeContent}>
					<span className={styles.describe}>기관</span> {`${thisBulletinData.org}`}
				</div>
				<div className={styles.describeContent}>
					<span className={styles.describe}>발행년도</span>{' '}
					{`${thisBulletinData.date[0]}년`}
				</div>
			</div>
		</div>
	);
}

export default HbsPreview;
